import React, { useState } from "react";
import videoSource from '../promo.mp4';

const PromoVideoPage = () => {

    const [videoDisplay, setVideoDisplay] = useState(require('../hero.mp4'));

    return (
        <div>
            <video 
                style={{position: "absolute", width: "100%", height: "100%"}}
                src={videoSource}
                autoPlay={false}
                controls
                playsInline
            >
            </video>
        </div>
    )
}
export default PromoVideoPage;